// Labels for Nachträge. The paragraphs mirror utils/changeOrders/service.js (LEGAL_TEXT), which
// prints them on the documents.

export const STATE_COLORS = {
  draft: "default",
  announced: "gold",
  offered: "processing",
  ordered: "orange",
  approved: "success",
  rejected: "error",
  withdrawn: "default"
};

export const stateLabels = t => ({
  draft: t("Draft"),
  announced: t("Costs announced"),
  offered: t("Waiting for the customer"),
  ordered: t("Ordered, price open"),
  approved: t("Approved"),
  rejected: t("Rejected"),
  withdrawn: t("Withdrawn")
});

export const reasonLabels = t => ({
  customer_change: t("Changed work ordered by the customer"),
  additional_work: t("Additional work not in the contract"),
  unforeseen: t("Unforeseen conditions"),
  quantity_change: t("Quantity changed by more than 10 %"),
  omitted_work: t("Work left out"),
  unordered_work: t("Work done without an order"),
  hindrance: t("Hindrance / delay"),
  other: t("Other change")
});

export const contractLabels = t => ({
  vob: t("VOB/B contract"),
  bgb: t("BGB construction contract"),
  bgb_consumer: t("Consumer construction contract (BGB)")
});

export const pricingLabels = t => ({
  unit_prices: t("Prices of the main contract"),
  calculation: t("Own calculation"),
  hourly: t("By the hour (work reports)")
});

const LEGAL = {
  vob: {
    customer_change: "§ 1 Abs. 3, § 2 Abs. 5 VOB/B",
    additional_work: "§ 1 Abs. 4, § 2 Abs. 6 VOB/B",
    unforeseen: "§ 2 Abs. 5 und 6 VOB/B",
    quantity_change: "§ 2 Abs. 3 VOB/B",
    omitted_work: "§ 2 Abs. 4, § 8 Abs. 1 VOB/B",
    unordered_work: "§ 2 Abs. 8 VOB/B",
    hindrance: "§ 6 VOB/B",
    other: "VOB/B"
  },
  bgb: {
    customer_change: "§ 650b, § 650c BGB",
    additional_work: "§ 650b, § 650c BGB",
    unforeseen: "§ 650b, § 650c BGB",
    quantity_change: "§ 650c BGB",
    omitted_work: "§ 648 BGB",
    unordered_work: "§§ 677 ff. BGB",
    hindrance: "§ 642 BGB",
    other: "BGB"
  }
};

export const legalBasis = (contractBasis, reason) =>
  (LEGAL[contractBasis === "vob" ? "vob" : "bgb"] || {})[reason] || "";

/** What to keep in mind for a reason, shown under the picker. */
export const reasonHints = t => ({
  additional_work: t(
    "Under the VOB/B the extra payment must be announced before the work starts: send the cost notice first."
  ),
  unforeseen: t("Document what you found with photos before you continue."),
  quantity_change: t("Above 10 % more or less, either side may ask for a new unit price."),
  omitted_work: t("Enter left-out work with a negative quantity."),
  unordered_work: t("Paid only if the customer accepts it afterwards or it was necessary."),
  hindrance: t("Report a hindrance in writing right away, otherwise claims can be lost."),
  customer_change: t(
    "For a BGB contract the customer may order the change after 30 days without agreement."
  )
});
